export default "<div id=\"toolbarContainer\">\n    \n</div>";